module.exports = __webpack_public_path__ + "static/img/181002-Mary-Claire-King.5cd1aa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/181002-Mary-Claire-King.jpg
// module id = 4wZH
// module chunks = 0